// extracted by mini-css-extract-plugin
module.exports = {"tableInfo":"style__tableInfo__x56MP","infoBox":"style__infoBox__sFnX3","infoBoxLeft":"style__infoBoxLeft__fAmQE","infoBoxRight":"style__infoBoxRight__7tq-k"};